import React from "react";
import "./GestionDepotOffreCard.scss";
import PropTypes from "prop-types";
import img_groupe1 from "assets/logoOffre1.webp";
import { connect } from "react-redux";
import { formatContrat, truncate } from "Services/functions";
// import { Link } from "react-router-dom";
import GestionDepotOffreActions from "../GestionDepotOffreActions/GestionDepotOffreActions";
import { useState } from "react";
import Modal from "Components/Modal/Modal";
import OffreDetail from "Components/Offres/Offre/OffreDetail/OffreDetail";

const GestionDepotOffreCard = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];
  const [isVisibleDetail, setIsVisibleDetail] = useState(false);

  const findLogo = (offre) => {
    const logo = offre.university?.imageTransparentAndColorUrl;

    if (!offre?.transmitter?.name && offre.company) {
      return API_LINK + (offre.company?.logoLink || logo);
    }

    switch (offre.transmitter?.name) {
      case "Diffuseur":
        return props.secondaryTables.transmittersData
            ? props.secondaryTables.transmittersData.find(
                (transmitter) => transmitter.name == "Diffuseur"
            )?.imageUrl
            : API_LINK + logo;
      case "Etudiant":
        return API_LINK + offre.university.imageTransparentAndColorUrl;
      case "Admin":
        return props.secondaryTables.transmittersData
            ? props.secondaryTables.transmittersData.find(
                (transmitter) => transmitter.name == "Admin"
            )?.imageUrl
            : API_LINK + logo;
      case "Université":
        return API_LINK + logo;
      case "Recruteur":
        return API_LINK + (offre?.company?.logoLink || logo);
      case "Personnel":
        return API_LINK + offre.university.imageTransparentAndColorUrl;
      case "Alumni":
        return API_LINK + offre.university.imageTransparentAndColorUrl;
      default:
        return img_groupe1;
    }
  };

  return (
      <div className="gestion_offre_container">
        <div className="gestion_offre_container__logo">
          <div className="logo__card__gestion">
            <img src={findLogo(props.offre)} alt="Logo" title="Logo entreprise" />
            <div
                className="image__bg"
                style={{ backgroundImage: `url(${findLogo(props.offre)})` }}
            ></div>
          </div>
          <GestionDepotOffreActions
              statut={props.statut}
              id={props.id}
              offre={props.offre}
              feedback={props.feedback}
              secondClass="mobile"
          ></GestionDepotOffreActions>
        </div>
        {/* <Link
        to={{
          pathname: `/offre-detail/${props.id}`,
          params: props.id,
        }}
        target="_blank"
        rel="noopener noreferrer"
      > */}
        <div
            className="gestion_offre_container__info"
            onClick={() => setIsVisibleDetail(true)}
        >
          <h5 className="title">
            {props.titre ? (
                <>{props?.titre && truncate(props?.titre, 45)}</>
            ) : (
                "Titre non renseigné"
            )}
          </h5>
          <div className="gestion_offre_container__info__bottom">
            <h2>
              <i className="pi pi-building"> </i>
              {props.entreprise}
            </h2>
            <h2>
              <i className="pi pi-map-marker"></i> {truncate(props.lieu, 27)}
            </h2>

            <h2>
              <i className="pi pi-briefcase"></i> {formatContrat(props.contrat)}
            </h2>

            <h2>
              <i className="pi pi-id-card"></i> {props.niveau}
            </h2>
          </div>
          <div className="description">
            <span>{props?.description && truncate(props?.description, 170)}</span>
          </div>
        </div>
        {/* </Link> */}

        <div className="gestion_offre_container__bouton">
          <GestionDepotOffreActions
              statut={props.statut}
              id={props.id}
              offre={props.offre}
              feedback={props.feedback}
              secondClass="desktop"
          ></GestionDepotOffreActions>
          {props.statut.statusLabel == "Archivé" && (
              <span className="desactive">Archivée</span>
          )}
          {props.statut.statusLabel == "Publié" && (
              <span className="actif">Publiée</span>
          )}
          {props.statut.statusLabel == "En Attente" && (
              <span className="attente">En attente</span>
          )}
          {props.statut.statusLabel == "Refusé" && (
              <span className="refuse">Refusée</span>
          )}
          {props.statut.statusLabel == "Brouillon" && (
              <span className="brouillon">Brouillon</span>
          )}
        </div>

        {isVisibleDetail && (
            <Modal
                visible={isVisibleDetail}
                setVisible={setIsVisibleDetail}
                header={`Détail de l'offre`}
            >
              <OffreDetail id={props.id}></OffreDetail>
            </Modal>
        )}
      </div>
  );
};

GestionDepotOffreCard.propTypes = {
  titre: PropTypes.string,
  lieu: PropTypes.string,
  contrat: PropTypes.string,
  niveau: PropTypes.string,
  statut: PropTypes.object,
  description: PropTypes.string,
  image: PropTypes.string,
  entreprise: PropTypes.string,
  id: PropTypes.number,
  offre: PropTypes.object,
  feedback: PropTypes.string,
  secondaryTables: PropTypes.object,
};

const mapStateToProps = (state) => ({
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = () => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GestionDepotOffreCard);
